import axios from "axios";

const networkError = {
  status: 0,
  message:
    "Network error, This could be a CORS/Server timeout/Dropped internet connection - issue.",
};

const instance = axios.create();

const setAuthHeader = (data) => {
  instance.defaults.headers.common.Authorization = data;
};

const request = (options, save = {}) => {
  return new Promise((resolve, reject) => {
    instance(options)
      .then((response) => {
        resolve({
          status: response?.status || networkError.status,
          data: response?.data || networkError,
          payload: { ...options, ...save },
        });
      })
      .catch(({ response = {} }) => {
        resolve({
          status: response?.status || networkError.status,
          data: response?.data || networkError,
          payload: { ...options, ...save },
        });
      });
  });
};

export default request;
export { setAuthHeader };
